export class Model{
    constructor(
        public idModelo: number,
        public idMercado: number,
        public fromDate: string,
        public rangoTiempo: string,
        //private int idmercado;
       // private int idNectumLista;
        //private int idNectumModelo;
        public Nombre: string,
        public guardado: string,
        public tipo: number,
        public periodoModeloPeriodico: number,
        public condicion: string,
        public fechaInicio:string,
        public bajista : boolean,
        public stoploss: number,
        public periodo: number,
        public porcentajePrima: number,
        public valorRiesgo: number
    ){}
}